import { CheckCreator } from 'lib/utils/formValidation/formValidation';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
const isMaxNumber: CheckCreator = (maxValue: number) => (value: number) => value <= maxValue;

export default isMaxNumber;
